@if (!isLoading) {
	<div
		class="input-grid-container"
		[ngStyle]="{ 'grid-template-columns': 'repeat(' + _columns + ', 1fr)' }"
		[ngClass]="{ loading: isLoadingLabels || isLoadingAllowedMimeType }">
		<ng-container *ngFor="let formItem of setGenericForm; let index = index">
			<ng-container *ngIf="!formItem.hidden || formItem.hidden?.toString() == '0'">
				<div
					class="input-cell"
					[ngClass]="{ 'hide-title': hideTitle }"
					*ngIf="
						formItem.inputType === 'string' ||
						formItem.inputType === 'number' ||
						formItem.inputType === 'money' ||
						formItem.inputType === 'date' ||
						formItem.inputType === 'time' ||
						formItem.inputType === 'datetime' ||
						formItem.inputType === 'select' ||
						formItem.inputType === 'select-iac/number' ||
						formItem.inputType === 'select-iac/string' ||
						formItem.inputType === 'select-iac' ||
						formItem.inputType === 'select-approver' ||
						formItem.inputType === 'iac' ||
						formItem.inputType === 'boolean' ||
						formItem.inputType === 'attachment'
					">
					<div [ngClass]="{ 'bold-label': boldLabel, 'hide-title': hideTitle }" class="title-label">
						<span class="text"
							>{{
								formItem.label && formItem.label !== ''
									? labels[formItem.label]
										? labels[formItem.label]
										: formItem.label
									: formItem.name
							}}
							{{ formItem.required == 1 ? '*' : '' }}</span
						>
						<span *ngIf="formItem.tip" [title]="labels[formItem.tip] ? labels[formItem.tip] : formItem.tip"
							><fa-icon [icon]="icons.faQuestionCircle"></fa-icon
						></span>
						<span *ngIf="formItem.inputType === 'attachment'" [title]="allowedMimeTypeTip"
							><fa-icon [icon]="icons.faQuestionCircle"></fa-icon
						></span>
						<span class="cursor" *ngIf="formItem.tipFunction" (click)="formItem.tipFunction()"
							><fa-icon [icon]="icons.faInfoCircle"></fa-icon
						></span>
						<span class="cursor" *ngIf="formItem.existInAd" (click)="formItem.adFunction()"
							><fa-icon [icon]="icons.faInfoCircle" class="existInAd"></fa-icon
						></span>
						<span class="cursor" *ngIf="formItem.notExistInAd" (click)="formItem.adFunction()"
							><fa-icon [icon]="icons.faInfoCircle" class="notExistInAd"></fa-icon
						></span>
					</div>
					<span class="dots"></span>
					<input
						[ngClass]="{
							link: formItem.rawInputType === 'attachment' && (formItem.disabled || disabled),
							'required-alert': formItem.alert === true,
						}"
						[type]="formItem.inputType"
						[value]="
							formItem.autoWrite
								? handleAutoWriteValue(index)
								: formItem.items &&
									  formItem.items[0] &&
									  formItem.items[0].values &&
									  formItem.items[0].values[0] == formItem.values[0]
									? labels[formItem.items[0].label]
										? labels[formItem.items[0].label]
										: formItem.items[0].name
									: formItem.stringifiedValue
										? formItem.stringifiedValue
										: formItem.values[0]
											? formItem.values[0]
											: ''
						"
						(input)="
							formItem.alert = false;
							formItem.rawValues[0] = formItem.values[0] = $event.target.value;
							formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
							valueTapField(formItem)
						"
						(change)="
							formItem.alert = false;
							formItem.rawValues[0] = formItem.values[0] = $event.target.value;
							formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
							valueTapField(formItem)
						"
						[attr.min]="formItem.inputType === 'number' ? '0' : null"
						[attr.max]="formItem.inputType === 'number' ? '2147483647' : null"
						[attr.maxlength]="formItem.size ? formItem.size : null"
						[readonly]="formItem.disabled || disabled"
						(click)="
							formItem.rawInputType === 'attachment' && (formItem.disabled || disabled)
								? downloadFile(formItem.values[0], formItem.fileSource)
								: null
						"
						*ngIf="formItem.inputType === 'string' || formItem.inputType === 'number' || formItem.inputType === 'date'" />
					<input
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						[type]="'number'"
						[value]="
							formItem.autoWrite
								? handleAutoWriteValue(index)
								: formItem.values[0]
									? formItem.values[0]
									: formatMoneyInput(formItem)
						"
						(input)="
							formItem.alert = false;
							formItem.values[0] = $event.target.value;
							formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
							valueTapField(formItem)
						"
						[attr.step]="'0.1'"
						[attr.maxlength]="formItem.size ? formItem.size : null"
						[disabled]="formItem.disabled || disabled"
						(blur)="formatMoneyInput(formItem)"
						*ngIf="formItem.inputType === 'money'" />
					<select
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						[value]="formItem.values[0]"
						(change)="
							formItem.alert = false;
							formItem.values[0] = $event.target.value;
							formItem.subSelect && formItem.subSelect.length > 0
								? handleSubSelect(formItem.subSelect, $event.target.value)
								: null;
							formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
							valueTapField(formItem)
						"
						[disabled]="formItem.disabled || disabled"
						*ngIf="formItem.inputType === 'select' || formItem.inputType === 'select-approver'">
						<ng-container *ngIf="formItem.inputType === 'select' || formItem.inputType === 'select-approver'">
							<option [value]="-1" *ngIf="formItem.hideUndefined != true">
								{{
									formItem.isLoading
										? labels.lbl_edocs_carregando
										: formItem.disabled || disabled
											? ''
											: labels.lbl_geral_selecione
								}}
							</option>
							@for (selectOption of formItem.items; track selectOption) {
								@if (selectOption.hidden !== true) {
									<option
										[value]="selectOption.values[0]"
										[selected]="selectOption.values[0]?.toString() === formItem.values[0]?.toString()"
										[disabled]="selectOption.disabled">
										{{
											selectOption.label && selectOption.label !== ''
												? labels[selectOption.label]
													? labels[selectOption.label]
													: selectOption.label
												: selectOption.name
										}}
									</option>
								}
							}
						</ng-container>
					</select>
					<cpi-input-with-autocomplete
						[alert]="formItem.alert === true"
						[availableOptionsGenericForm]="formItem.items"
						[minInputLength]="0"
						[setValue]="formItem.values[0]"
						[alert]="formItem.alert"
						[disabled]="formItem.disabled || disabled"
						(onValueChange)="
							formItem.alert = false;
							formItem.rawValues[0] = formItem.values[0] = $event;
							formItem.subSelect && formItem.subSelect.length > 0 ? handleSubSelect(formItem.subSelect, $event) : null;
							formItem.extraFunction ? formItem.extraFunction($event) : null;
							valueTapField(formItem)
						"
						(getInputText)="formItem.alert = false"
						*ngIf="
							formItem.inputType === 'select-iac' ||
							formItem.inputType === 'select-iac/number' ||
							formItem.inputType === 'select-iac/string'
						">
					</cpi-input-with-autocomplete>
					<div [ngClass]="{ 'required-alert': formItem.alert === true }" *ngIf="formItem.inputType === 'boolean'">
						<cpi-checkbox
							[value]="formItem.values[0]"
							[innerText]="formItem.values[0] == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao"
							(oValue)="
								formItem.alert = false;
								formItem.rawValues[0] = $event;
								formItem.values[0] = $event;
								formItem.subSelect && formItem.subSelect.length > 0
									? handleCheckboxSubSelect(formItem.subSelect, $event)
									: null;
								valueTapField(formItem)
							"
							[disable]="formItem.disabled || disabled">
						</cpi-checkbox>
					</div>

					<input
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						type="time"
						matInput
						(input)="formItem.alert = false; formItem.values[0] = $event.target.value; valueTapField(formItem)"
						[value]="formItem.values[0]"
						[readonly]="formItem.disabled || disabled"
						*ngIf="formItem.inputType === 'time'" />

					<input
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						type="datetime-local"
						matInput
						(input)="formItem.alert = false; formItem.values[0] = $event.target.value; valueTapField(formItem)"
						[value]="formItem.values[0]"
						[readonly]="formItem.disabled || disabled"
						*ngIf="formItem.inputType === 'datetime'" />

					<div class="file-row" *ngIf="formItem.inputType === 'attachment'">
						<div class="button danger" *ngIf="taskFile.value" (click)="taskFile.value = ''; handleFileTask(taskFile, index)">
							<fa-icon [icon]="icons.faTimes"></fa-icon>
						</div>
						<input
							type="file"
							[id]="'taskFile' + index"
							#taskFile
							(change)="handleFileTask(taskFile, index)"
							[accept]="allowedMimeTypeStr" />
						<label
							class="button taskFile"
							[ngClass]="{ 'required-alert': formItem.alert === true }"
							[for]="'taskFile' + index"
							>{{ taskFile.value ? taskFile.value.split('\\')[2] : labels.lbl_geral_anexar_arquivo }}</label
						>
					</div>
				</div>

				<div
					class="input-cell vertical period-date"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'period-date'">
					<span>{{ labels[formItem.label] }}: {{ formItem.required == 1 ? '*' : '' }}</span>

					<div class="button-container" *ngIf="!periodDatePeriodOnly">
						<div
							class="button danger"
							[ngClass]="{ success: !formItem.periodType || formItem.periodType === 'period' }"
							(click)="formItem.periodType = 'period'; formItem.values = []; valueTapField(formItem)">
							{{ labels.lbl_cmdb_period }}
						</div>
						<div
							class="button danger"
							[ngClass]="{ success: formItem.periodType && formItem.periodType === 'month1' }"
							(click)="
								formItem.periodType = 'month1';
								formItem.values[0] = 'month1';
								formItem.values[1] = 'month2';
								valueTapField(formItem)
							">
							{{ labels.lbl_primeiro_dia_do_mes }}
						</div>
						<div
							class="button danger"
							[ngClass]="{ success: formItem.periodType && formItem.periodType === 'today' }"
							(click)="
								formItem.periodType = 'today';
								formItem.values[0] = 'today';
								formItem.values[1] = 'today';
								valueTapField(formItem)
							">
							{{ labels.lbl_geral_hoje }}
						</div>
						<div
							class="button danger"
							[ngClass]="{ success: formItem.periodType && formItem.periodType === 'month30s' }"
							(click)="
								formItem.periodType = 'month30s';
								formItem.values[0] = 'month30s';
								formItem.values[1] = 'month30s';
								valueTapField(formItem)
							">
							{{ labels.lbl_ultimos_30_dias }}
						</div>
						<div
							class="button danger"
							[ngClass]="{ success: formItem.periodType && formItem.periodType === 'month7s' }"
							(click)="
								formItem.periodType = 'month7s';
								formItem.values[0] = 'month7s';
								formItem.values[1] = 'month7s';
								valueTapField(formItem)
							">
							{{ labels.lbl_ultimos_7_dias }}
						</div>
					</div>

					<div
						[ngClass]="{ 'hide-form': formItem.periodType && formItem.periodType !== 'period' }"
						class="dotted-input-container">
						<span>{{ labels.lbl_geral_de }}:</span>
						<input
							type="date"
							[value]="!formItem.periodType || formItem.periodType === 'period' ? formItem.values[0] : ''"
							(input)="formItem.values[0] = $event.target.value; valueTapField(formItem)"
							(change)="formItem.values[0] = $event.target.value; valueTapField(formItem)" />
					</div>

					<div
						[ngClass]="{ 'hide-form': formItem.periodType && formItem.periodType !== 'period' }"
						class="dotted-input-container">
						<span>{{ labels.lbl_geral_para }}:</span>
						<input
							type="date"
							[value]="!formItem.periodType || formItem.periodType === 'period' ? formItem.values[1] : ''"
							(input)="formItem.values[1] = $event.target.value; valueTapField(formItem)"
							(change)="formItem.values[1] = $event.target.value; valueTapField(formItem)" />
					</div>
				</div>

				<div
					class="input-cell multi-select"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					(mouseleave)="formItem.draggingItem = undefined; formItem.draggingSource = undefined; formItem.isDraggingItem = false"
					*ngIf="formItem.inputType === 'multi-select'"
					#multiSelect>
					<span [ngClass]="{ 'bold-label': boldLabel }" class="title-label"
						>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }} {{ formItem.required == 1 ? '*' : '' }}</span
					>

					<div class="multi-header">{{ labels.lbl_geral_disponiveis }}</div>
					<div></div>
					<div class="multi-header">{{ labels.lbl_geral_selecionados }}</div>

					<div><input type="text" tabindex="-1" (input)="formItem.filterItem[0] = $event.target.value" /></div>
					<div></div>
					<div><input type="text" tabindex="-1" (input)="formItem.filterValues[0] = $event.target.value" /></div>

					<div
						class="multi-select-box"
						[ngStyle]="{ 'height.px': formItem.boxHeight }"
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						tabindex="0"
						(mouseleave)="multiSelectClearHold(formItem)"
						(keydown)="multiSelectItemKeyboardHandler(formItem, $event)"
						(blur)="multiSelectClearHold(formItem)">
						<div
							[ngClass]="{
								disabled: item.unchangeable || formItem.disabled || disabled,
								multiSelectFocus:
									(formItem.focusItemIndex != null && formItem.focusItemIndex == itemIndex) ||
									(formItem.isHeld &&
										formItem.focusSide === 'item' &&
										((itemIndex >= formItem.heldFirstIndex && itemIndex <= formItem.heldLastIndex) ||
											(itemIndex <= formItem.heldFirstIndex && itemIndex >= formItem.heldLastIndex))),
							}"
							[ngStyle]="{
								display:
									!formItem.rawValues.includes(item.values[0]) &&
									(!formItem.filterItem ||
										!formItem.filterItem[0] ||
										formItem.filterItem[0] === '' ||
										item.label.toLowerCase().includes(formItem.filterItem[0].toLowerCase()) ||
										(labels[item.label]
											? labels[item.label].toLowerCase().includes(formItem.filterItem[0].toLowerCase())
											: item.name.toLowerCase().includes(formItem.filterItem[0].toLowerCase())))
										? 'unset'
										: 'none',
							}"
							*ngFor="let item of formItem.items; let itemIndex = index">
							<!-- <span><fa-icon [icon]="icons.faAngleRight"></fa-icon></span> -->
							<span
								[title]="labels[item.label] ? labels[item.label] : item.label"
								(mouseenter)="
									formItem.focusItemIndex = itemIndex; formItem.isHeld ? multiSelectMoveHold(formItem, itemIndex) : null
								"
								(mousedown)="formItem.focusSide = 'item'; multiSelectStartHold(formItem, itemIndex)"
								(mouseup)="multiSelectEndHold(formItem); formItem.focusSide = undefined">
								{{ labels[item.label] ? labels[item.label] : item.label }}
							</span>
							<!-- <div
							class="drop-option"
							(mouseenter)="moveDragItem(formItem, formItem.draggingSource, 'items', itemIndex)"
							(mouseup)="formItem.draggingItem = undefined; formItem.draggingSource = undefined; formItem.isDraggingItem = false"
							*ngIf="formItem.isDraggingItem">
							</div> -->
						</div>
					</div>
					<div class="arrows">
						<span
							(click)="
								pushAllMultiSelectValues(formItem);
								formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
								valueTapField(formItem)
							"
							><fa-icon [icon]="icons.faAngleRight"></fa-icon
						></span>
						<span
							(click)="
								pullAllMultiSelectValues(formItem);
								formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
								valueTapField(formItem)
							"
							><fa-icon [icon]="icons.faAngleLeft"></fa-icon
						></span>
					</div>
					<div
						class="multi-select-box"
						[ngStyle]="{ 'height.px': formItem.boxHeight }"
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						tabindex="0"
						(mouseleave)="multiSelectClearHold(formItem)"
						(keydown)="multiSelectValueKeyboardHandler(formItem, $event)"
						(blur)="multiSelectClearHold(formItem)">
						<div
							[ngClass]="{
								disabled: value.unchangeable || formItem.disabled || disabled,
								multiSelectFocus:
									(formItem.focusValueIndex != null && formItem.focusValueIndex == valueIndex) ||
									(formItem.isHeld &&
										formItem.focusSide === 'value' &&
										((valueIndex >= formItem.heldFirstIndex && valueIndex <= formItem.heldLastIndex) ||
											(valueIndex <= formItem.heldFirstIndex && valueIndex >= formItem.heldLastIndex))),
							}"
							[ngStyle]="{
								display:
									!formItem.filterValues ||
									!formItem.filterValues[0] ||
									formItem.filterValues[0] === '' ||
									value.label.toLowerCase().includes(formItem.filterValues[0].toLowerCase()) ||
									(labels[value.label]
										? labels[value.label].toLowerCase().includes(formItem.filterValues[0].toLowerCase())
										: value.name.toLowerCase().includes(formItem.filterValues[0].toLowerCase()))
										? 'unset'
										: 'none',
							}"
							*ngFor="let value of formItem.values; let valueIndex = index">
							<span
								class="drag-button"
								(mousedown)="
									formItem.draggingItem = value;
									formItem.draggingSource = 'values';
									setDragPosition(multiSelect, formItem, $event);
									formItem.isDraggingItem = true
								"
								(mouseenter)="!formItem.isHeld ? multiSelectClearHold(formItem) : null"
								*ngIf="formItem.allowDragAndDrop"
								><fa-icon [icon]="icons.faGripVertical"></fa-icon>
							</span>
							<span
								[title]="labels[value.label] ? labels[value.label] : value.label"
								(mouseenter)="
									formItem.focusValueIndex = valueIndex;
									formItem.isHeld ? multiSelectMoveHold(formItem, valueIndex) : null
								"
								(mousedown)="formItem.focusSide = 'value'; multiSelectStartHold(formItem, valueIndex)"
								(mouseup)="multiSelectEndHold(formItem); formItem.focusSide = undefined">
								{{ labels[value.label] ? labels[value.label] : value.label }}
							</span>
							<div
								class="drop-option"
								(mouseenter)="moveDragItem(formItem, formItem.draggingSource, 'values', valueIndex)"
								(mouseup)="
									formItem.draggingItem = undefined; formItem.draggingSource = undefined; formItem.isDraggingItem = false
								"
								*ngIf="formItem.isDraggingItem"></div>
						</div>
					</div>
					<div
						class="drag-screen"
						(mousemove)="setDragPosition(multiSelect, formItem, $event)"
						(mouseup)="formItem.isDraggingItem = false"
						*ngIf="formItem.isDraggingItem"></div>
				</div>

				<div
					class="input-cell vertical"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'textarea'">
					<span [ngClass]="{ 'hide-title': hideTitle }"
						>{{ formItem.label ? formItem.label : formItem.name }}: {{ formItem.required == 1 ? '*' : '' }}</span
					>
					<textarea
						[ngClass]="{ 'required-alert': formItem.alert === true }"
						rows="4"
						[value]="formItem.values[0]"
						(input)="
							formItem.alert = false;
							formItem.rawValues[0] = formItem.values[0] = $event.target.value;
							formItem.extraFunction ? formItem.extraFunction($event.target.value) : null;
							valueTapField(formItem)
						"
						[disabled]="formItem.disabled || disabled">
					</textarea>
				</div>

				<div
					class="input-cell multi-input"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'multi-input'">
					<span [ngClass]="{ 'bold-label': boldLabel }" class="multi-label"
						>{{
							formItem.label && formItem.label !== ''
								? labels[formItem.label]
									? labels[formItem.label]
									: formItem.label
								: formItem.name
						}}
						<ng-container *ngIf="formItem.required == 1"> *</ng-container></span
					>
					<ng-container *ngIf="!formItem.disabled && !disabled">
						<ng-container *ngFor="let jindex = index; let formInput; of: formItem.items">
							<div class="input-cell" *ngIf="!formInput.hidden || formInput.hidden != true">
								<span *ngIf="formInput.inputType !== 'multi-select'"
									>{{
										formInput.label && formInput.label !== ''
											? labels[formInput.label]
												? labels[formInput.label]
												: formInput.label
											: formInput.name
									}}
									<span *ngIf="formInput.tip" [title]="labels[formItem.tip] ? labels[formItem.tip] : formInput.tip"
										><fa-icon [icon]="icons.faQuestionCircle"></fa-icon
									></span>
									{{ formInput.required ? '*' : '' }}</span
								>
								<input
									[ngClass]="{ 'required-alert': formInput.alert === true }"
									type="text"
									[value]="formInput.values[0]"
									(input)="
										formItem.items && formItem.items.length >= 7
											? (formItem.filterValues[jindex] = $event.target.value)
											: null;
										formInput.values[0] = $event.target.value;
										formInput.alert = false
									"
									*ngIf="formInput.inputType === 'string'" />
								<select
									[ngClass]="{ 'required-alert': formInput.alert === true }"
									(change)="
										formItem.items && formItem.items.length >= 7
											? (formItem.filterValues[jindex] = $event.target.value)
											: null;
										formInput.values[0] = $event.target.value;
										formInput.alert = false;
										formInput.extraFunction ? formInput.extraFunction($event.target.value) : null
									"
									*ngIf="formInput.inputType === 'select' && formInput.hidden !== false">
									<option
										[value]="''"
										[selected]="formInput.values[0]?.toString() === ''"
										*ngIf="formInput.hideUndefined != true">
										{{ labels.lbl_geral_selecione }}
									</option>
									<ng-container *ngFor="let option of formInput.items">
										<option
											[disabled]="option.disabled"
											[value]="option.values[0]"
											[selected]="formInput.values[0]?.toString() === option.values[0]?.toString()"
											*ngIf="option.hidden != true">
											{{ labels[option.label] ? labels[option.label] : option.name }}
										</option>
									</ng-container>
								</select>
								<input
									type="date"
									[(ngModel)]="formInput.values[0]"
									[ngModelOptions]="{ standalone: true }"
									(ngModelChange)="onDateChange($event, formInput)"
									[ngClass]="{ 'required-alert': formInput.alert === true }"
									[readonly]="formInput.disabled || disabled"
									*ngIf="formInput.inputType === 'date'" />
								<input
									type="time"
									matInput
									(input)="
										formItem.items && formItem.items.length >= 7
											? (formItem.filterValues[jindex] = $event.target.value)
											: null;
										formInput.values[0] = $event.target.value;
										formInput.alert = false
									"
									[value]="formInput.values[0]"
									*ngIf="formInput.inputType === 'time'" />

								<input
									type="datetime-local"
									matInput
									(input)="
										formItem.items && formItem.items.length >= 7
											? (formItem.filterValues[jindex] = $event.target.value)
											: null;
										formInput.values[0] = $event.target.value;
										formInput.alert = false
									"
									[value]="formInput.values[0]"
									*ngIf="formInput.inputType === 'datetime'" />

								<cpi-checkbox
									[value]="formInput.values[0]"
									[innerText]="formInput.values[0] == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao"
									[disable]="formInput.disabled || disabled"
									(oValue)="
										formItem.items && formItem.items.length >= 7 ? (formItem.filterValues[jindex] = $event) : null;
										formInput.rawValues[0] = $event;
										formInput.values[0] = $event;
										valueTapField(formItem)
									"
									*ngIf="formInput.inputType === 'boolean'">
								</cpi-checkbox>

								<!-- <div
								class="textarea-like"
								(input)="formItem.items && formItem.items.length >= 7 ? formItem.filterValues[jindex] = $event.target.innerHTML : null; formInput.values[0] = $event.target.innerHTML; valueTapField(formItem)"
								contenteditable
								*ngIf="formInput.inputType === 'textarea'">
									{{formInput.values[0]}}
								</div> -->

								<div
									class="input-cell multi-select"
									[ngStyle]="{ 'grid-column': 'span ' + _columns }"
									*ngIf="formInput.inputType === 'multi-select'">
									<span class="title-label"
										>{{ labels[formInput.label] ? labels[formInput.label] : formInput.name }}
										{{ formItem.required == 1 ? '*' : '' }}</span
									>

									<div class="multi-header">{{ labels.lbl_geral_disponiveis }}</div>
									<div></div>
									<div class="multi-header">{{ labels.lbl_geral_selecionados }}</div>

									<div><input type="text" tabindex="-1" (input)="formInput.filterItem[0] = $event.target.value" /></div>
									<div></div>
									<div><input type="text" tabindex="-1" (input)="formInput.filterValues[0] = $event.target.value" /></div>

									<div
										class="multi-select-box"
										[ngStyle]="{ 'height.px': formInput.boxHeight }"
										[ngClass]="{ 'required-alert': formInput.alert === true }">
										<ng-container *ngFor="let item of formInput.items; let itemIndex = index">
											<span
												[ngStyle]="{
													display:
														!formInput.values.includes(item) &&
														(!formInput.filterItem ||
															!formInput.filterItem[0] ||
															formInput.filterItem[0] === '' ||
															item.label.toLowerCase().includes(formInput.filterItem[0].toLowerCase()) ||
															(labels[item.label]
																? labels[item.label]
																		.toLowerCase()
																		.includes(formInput.filterItem[0].toLowerCase())
																: item.name.toLowerCase().includes(formInput.filterItem[0].toLowerCase())))
															? 'unset'
															: 'none',
												}"
												[title]="labels[item.label] ? labels[item.label] : item.name"
												(click)="addMultiInputMultiSelectValue(index, jindex, itemIndex)">
												<fa-icon [icon]="icons.faAngleRight"></fa-icon
												>{{ labels[item.label] ? labels[item.label] : item.name }}
											</span>
										</ng-container>
									</div>
									<div class="arrows">
										<span
											(click)="
												pushAllMultiInputMultiSelectValues(formInput, jindex);
												formInput.extraFunction ? formInput.extraFunction($event.target.value) : null;
												valueTapField(formItem)
											"
											><fa-icon [icon]="icons.faAngleRight"></fa-icon
										></span>
										<span
											(click)="
												pullAllMultiInputMultiSelectValues(formInput, jindex);
												formInput.extraFunction ? formInput.extraFunction($event.target.value) : null;
												valueTapField(formItem)
											"
											><fa-icon [icon]="icons.faAngleLeft"></fa-icon
										></span>
									</div>
									<div
										class="multi-select-box"
										[ngStyle]="{ 'height.px': formInput.boxHeight }"
										[ngClass]="{ 'required-alert': formInput.alert === true }">
										<ng-container *ngFor="let value of formInput.values; let valueIndex = index">
											<span
												[ngClass]="{ disabled: value.unchangeable || formInput.disabled || disabled }"
												[ngStyle]="{
													display:
														!formInput.filterValues ||
														!formInput.filterValues[0] ||
														formInput.filterValues[0] === '' ||
														value.label.toLowerCase().includes(formInput.filterValues[0]?.toLowerCase()) ||
														(labels[value.label]
															? labels[value.label]
																	.toLowerCase()
																	.includes(formInput.filterValues[0]?.toLowerCase())
															: value.name.toLowerCase().includes(formInput.filterValues[0]?.toLowerCase()))
															? 'unset'
															: 'none',
												}"
												[title]="labels[value.label] ? labels[value.label] : value.name"
												(click)="removeMultiInputMultiSelectValue(index, jindex, valueIndex)">
												<fa-icon [icon]="icons.faAngleLeft"></fa-icon>
												{{ labels[value.label] ? labels[value.label] : value.name }}
											</span>
										</ng-container>
									</div>
								</div>
							</div>
						</ng-container>

						<cpi-dot-bounce-loading-effect
							[color]="'var(--primary-color-1)'"
							*ngIf="formItem.isLoading"></cpi-dot-bounce-loading-effect>

						<div class="button-container">
							<div
								class="button"
								(click)="cleanMultiInputItems(formItem)"
								*ngIf="formItem.items && formItem.items.length >= 7 && formItem.values && formItem.values.length > 0">
								{{ labels.lbl_geral_limpar_campos }}
							</div>
							<div
								class="button"
								(click)="filterMultiInputValues(formItem)"
								*ngIf="formItem.items && formItem.items.length >= 7 && formItem.values && formItem.values.length > 0">
								{{ labels.lbl_geral_pesquisar }}
							</div>
							<div class="button" (click)="addMultiInputValue(index)" *ngIf="formItem.editingIndex == undefined">
								{{ labels.lbl_geral_adicionar }}
							</div>
							<div class="button" (click)="formItem.editingIndex = undefined" *ngIf="formItem.editingIndex != undefined">
								{{ labels.lbl_geral_cancelar }}
							</div>
							<div class="button" (click)="updateMultiInputValue(index)" *ngIf="formItem.editingIndex != undefined">
								{{ labels.lbl_atualizar_item }} {{ formItem.editingIndex }}
							</div>
						</div>
					</ng-container>

					<!--- VALORES SALVOS NO MULTI INPUT --->
					<ng-container *ngIf="formItem.hideMultiInputBox == undefined || formItem.hideMultiInputBox == false">
						<div
							class="multi-input-box-container"
							[ngClass]="{ 'required-alert': formItem.alert === true }"
							*ngIf="!formItem.forceVertical && (!formItem.items || (formItem.items && formItem.items.length < 7))">
							<div
								class="multi-input-box head"
								[ngStyle]="{ 'grid-template-columns': '2em repeat(' + formItem.items.length + ', 1fr) 10%' }">
								<span></span>
								<span *ngFor="let formInput of formItem.items; let itemIndex = index">
									<input
										type="text"
										tabindex="-1"
										class="hidden-input"
										(input)="formItem.filterValues[itemIndex] = $event.target.value; filterMultiInputValues(formItem)"
										[placeholder]="
											formInput.label && formInput.label !== ''
												? labels[formInput.label]
													? labels[formInput.label]
													: formInput.label
												: formInput.name
										" />
								</span>
								<span *ngIf="!formItem.disabled && !disabled">{{ labels.lbl_bulletin_actions }}</span>
							</div>
							<div class="multi-input-box body">
								<ng-container *ngFor="let item of formItem.outItems; let outItemIndex = index">
									<div
										class="item"
										[ngClass]="{
											'required-alert': formItem.alertIndex == outItemIndex,
											editing: formItem.editingIndex == outItemIndex,
										}"
										[ngStyle]="{ 'grid-template-columns': '2em repeat(' + formItem.items.length + ', 1fr) 10%' }">
										<span>{{ outItemIndex }}</span>
										<ng-container *ngFor="let value of item; let jindex = index">
											<span>
												{{ formatMultiInputTextCallBack(value, formItem, jindex) }}
											</span>
										</ng-container>
										<div class="action-cell" *ngIf="!formItem.disabled && !disabled">
											<span
												(click)="
													deleteConfirmRef.classList.contains('confirmClick')
														? removeMultiInputValue(index, outItemIndex)
														: confirmButton(deleteConfirmRef)
												"
												#deleteConfirmRef
												><fa-icon [icon]="icons.faTrash"></fa-icon
											></span>
											<span
												(click)="
													formItem.editingIndex == outItemIndex
														? (formItem.editingIndex = undefined)
														: editMultiInputValue(formItem, outItemIndex)
												"
												*ngIf="formItem.allowEdit"
												><fa-icon [icon]="icons.faSquarePen"></fa-icon
											></span>
										</div>
									</div>
								</ng-container>
							</div>
						</div>

						<!--- VALORES SALVOS NO MULTI INPUT PARA MAIS DE 7 COLUNAS --->
						<div
							[ngStyle]="{ 'grid-column': 'span ' + _columns }"
							*ngIf="
								formItem.forceVertical ||
								(formItem.items && formItem.items.length >= 7 && formItem.values && formItem.values.length > 0)
							">
							{{ labels.lbl_indicadores_salvos }}:
						</div>
						<div
							class="many-multi-input-box-container"
							[ngClass]="{ 'required-alert': formItem.alert === true }"
							[ngStyle]="{ 'grid-column': 'span ' + (_columns + 2) }"
							*ngIf="formItem.forceVertical || (formItem.items && formItem.items.length >= 7)">
							<div
								class="item"
								[ngClass]="{ 'required-alert': formItem.alertIndex == index, editing: formItem.editingIndex == index }"
								*ngFor="let item of formItem.outItems; let index = index">
								<div>{{ index }}.</div>
								<ng-container *ngFor="let value of item; let jindex = index">
									<div class="input-cell" *ngIf="formItem.items && formItem.items[jindex]">
										<span>{{
											labels[formItem.items[jindex].label]
												? labels[formItem.items[jindex].label]
												: formItem.items[jindex].label
										}}</span>
										<div class="textarea-like" [innerHTML]="value"></div>
									</div>
								</ng-container>
								<ng-container *ngIf="!formItem.disabled && !disabled">
									<span
										class="action-cell"
										(click)="
											deleteConfirmRef.classList.contains('confirmClick')
												? removeMultiInputValue(formItem, index)
												: confirmButton(deleteConfirmRef)
										"
										#deleteConfirmRef
										><fa-icon [icon]="icons.faTrash"></fa-icon
									></span>
									<span
										class="action-cell"
										(click)="
											formItem.editingIndex == index
												? (formItem.editingIndex = undefined)
												: editMultiInputValue(formItem, index)
										"
										*ngIf="formItem.allowEdit"
										><fa-icon [icon]="icons.faSquarePen"></fa-icon
									></span>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</div>

				<div
					class="input-cell vertical"
					[ngClass]="{ 'required-alert': formItem.alert === true }"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'radio'">
					<span
						>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}:
						{{ formItem.required == 1 ? '*' : '' }}</span
					>
					<div class="radio-container" [ngStyle]="{ 'grid-template-columns': 'repeat(' + _columns + ', 1fr)' }">
						<cpi-checkbox
							[shared]="formItem.values[0]"
							[value]="radio.values[0]"
							[hideUncheck]="true"
							[innerText]="labels[radio.label] ? labels[radio.label] : radio.name"
							[disable]="formItem.disabled || disabled"
							(oValue)="
								formItem.values[0] = $event;
								formItem.rawValues[0] = $event;
								formItem.extraFunction ? formItem.extraFunction($event) : null;
								valueTapField(formItem)
							"
							*ngFor="let radio of formItem.items">
						</cpi-checkbox>
					</div>
				</div>

				<div
					class="input-cell vertical"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'checkbox'">
					<span
						>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}:
						{{ formItem.required == 1 ? '*' : '' }}</span
					>
					<div class="radio-container" [ngStyle]="{ 'grid-template-columns': 'repeat(' + _columns + ', 1fr)' }">
						<cpi-checkbox
							[value]="formItem.values[checkboxIndex]"
							[hideUncheck]="true"
							[innerText]="labels[radio.label] ? labels[radio.label] : radio.name"
							(oValue)="
								formItem.values[checkboxIndex] = $event;
								formItem.rawValues[checkboxIndex] = $event;
								handleCheckboxValues(formItem);
								formItem.extraFunction ? formItem.extraFunction($event) : null;
								valueTapField(formItem)
							"
							*ngFor="let radio of formItem.items; let checkboxIndex = index">
						</cpi-checkbox>
					</div>
				</div>

				<div
					class="input-cell vertical cronjob"
					[ngClass]="{ 'bold-label': boldLabel }"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					*ngIf="formItem.inputType === 'cronjob'">
					<span
						>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}:
						{{ formItem.required == 1 ? '*' : '' }}</span
					>
					<div class="cronjob-input-row">
						<div>
							<span>{{ labels['lbl_geral_minuto'].charAt(0).toUpperCase() + labels['lbl_geral_minuto'].slice(1) }}</span>
							<input
								[ngClass]="{ 'required-alert': formItem.alert === true || formItem.alert == 1 }"
								[value]="formItem.values[0]"
								(input)="formatCronjobMinute(formItem, minuteInputEl, $event.target.value); valueTapField(formItem)"
								(focus)="
									formItem.tip =
										this.labels['lbl_valores_validos'] +
										': ' +
										(formItem.limitCron && formItem.limitCron[0]?.length > 0
											? formItem.limitCron[0].join(', ')
											: '*, 0-59') +
										' ' +
										this.labels['lbl_separado_por_virgula'].toLowerCase() +
										'.'
								"
								(blur)="formItem.tip = ''"
								[disabled]="formItem.disabled || disabled"
								#minuteInputEl />
						</div>

						<div>
							<span>{{ labels['lbl_geral_hora'] }}</span>
							<input
								[ngClass]="{ 'required-alert': formItem.alert === true || formItem.alert == 2 }"
								[value]="formItem.values[1]"
								(input)="formatCronjobHour(formItem, hourInputEl, $event.target.value); valueTapField(formItem)"
								(focus)="
									formItem.tip =
										this.labels['lbl_valores_validos'] +
										': ' +
										(formItem.limitCron && formItem.limitCron[1]?.length > 0
											? formItem.limitCron[1].join(', ')
											: '*, 0-23') +
										' ' +
										this.labels['lbl_separado_por_virgula'].toLowerCase() +
										'.'
								"
								(blur)="formItem.tip = ''"
								[disabled]="formItem.disabled || disabled"
								#hourInputEl />
						</div>

						<div>
							<span>{{ labels['lbl_geral_dia'] }}</span>
							<input
								[ngClass]="{ 'required-alert': formItem.alert === true || formItem.alert == 3 }"
								[value]="formItem.values[2]"
								(input)="formatCronjobDay(formItem, dayInputEl, $event.target.value); valueTapField(formItem)"
								(focus)="
									formItem.tip =
										this.labels['lbl_valores_validos'] +
										': ' +
										(formItem.limitCron && formItem.limitCron[2]?.length > 0
											? formItem.limitCron[2].join(', ')
											: '*, 1-31') +
										' ' +
										this.labels['lbl_separado_por_virgula'].toLowerCase() +
										'.'
								"
								(blur)="formItem.tip = ''"
								[disabled]="formItem.disabled || disabled"
								#dayInputEl />
						</div>

						<div>
							<span>{{ labels['lbl_geral_mes'] }}</span>
							<input
								[ngClass]="{ 'required-alert': formItem.alert === true || formItem.alert == 4 }"
								[value]="formItem.values[3]"
								(input)="formatCronjobMonth(formItem, monthInputEl, $event.target.value); valueTapField(formItem)"
								(focus)="
									formItem.tip =
										this.labels['lbl_valores_validos'] +
										': ' +
										(formItem.limitCron && formItem.limitCron[3]?.length > 0
											? formItem.limitCron[3].join(', ')
											: '*, 1-12') +
										' ' +
										this.labels['lbl_separado_por_virgula'].toLowerCase() +
										'.'
								"
								(blur)="formItem.tip = ''"
								[disabled]="formItem.disabled || disabled"
								#monthInputEl />
						</div>

						<div>
							<span>{{ labels['lbl_geral_dia_da_semana'] }}</span>
							<input
								[ngClass]="{ 'required-alert': formItem.alert === true || formItem.alert == 5 }"
								[value]="formItem.values[4]"
								(input)="formatCronjobDayOfWeek(formItem, dayOfWeekInputEl, $event.target.value); valueTapField(formItem)"
								(focus)="
									formItem.tip =
										this.labels['lbl_valores_validos'] +
										': ' +
										(formItem.limitCron && formItem.limitCron[4]?.length > 0
											? formItem.limitCron[4].join(', ')
											: '*, 0-6') +
										' ' +
										this.labels['lbl_separado_por_virgula'].toLowerCase() +
										'.'
								"
								(blur)="formItem.tip = ''"
								[disabled]="formItem.disabled || disabled"
								#dayOfWeekInputEl />
						</div>
					</div>
					<div class="cronjob-text">
						<span class="italic" *ngIf="formItem.tip">{{ formItem.tip }}</span>
						<span>{{ formatCronjobText(formItem.values) }}</span>
					</div>
				</div>

				<!-- multi-select com apenas selecionaveis -->
				<div
					class="input-cell multi-select full-width"
					[ngStyle]="{ 'grid-column': 'span ' + _columns }"
					(mouseleave)="formItem.draggingItem = undefined; formItem.draggingSource = undefined; formItem.isDraggingItem = false"
					*ngIf="formItem.inputType === 'selectable-list'"
					#multiSelect>
					<span [ngClass]="{ 'bold-label': boldLabel }" class="title-label"
						>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }} {{ formItem.required == 1 ? '*' : '' }}</span
					>

					<div class="multi-header">
						{{ labels.lbl_geral_selecionados }}
						<div><input type="text" tabindex="-1" (input)="formItem.filterValues[0] = $event.target.value" /></div>

						<div
							class="multi-select-box"
							[ngStyle]="{ 'height.px': formItem.boxHeight }"
							[ngClass]="{ 'required-alert': formItem.alert === true }"
							tabindex="0"
							(mouseleave)="multiSelectClearHold(formItem)"
							(keydown)="multiSelectValueKeyboardHandler(formItem, $event)"
							(blur)="multiSelectClearHold(formItem)">
							<div
								[ngClass]="{
									disabled: value.unchangeable || formItem.disabled || disabled,
									multiSelectFocus:
										(formItem.focusValueIndex != null && formItem.focusValueIndex == valueIndex) ||
										(formItem.isHeld &&
											formItem.focusSide === 'value' &&
											((valueIndex >= formItem.heldFirstIndex && valueIndex <= formItem.heldLastIndex) ||
												(valueIndex <= formItem.heldFirstIndex && valueIndex >= formItem.heldLastIndex))),
								}"
								[ngStyle]="{
									display:
										!formItem.filterValues ||
										!formItem.filterValues[0] ||
										formItem.filterValues[0] === '' ||
										value.label.toLowerCase().includes(formItem.filterValues[0].toLowerCase()) ||
										(labels[value.label]
											? labels[value.label].toLowerCase().includes(formItem.filterValues[0].toLowerCase())
											: value.name.toLowerCase().includes(formItem.filterValues[0].toLowerCase()))
											? 'unset'
											: 'none',
								}"
								*ngFor="let value of formItem.values; let valueIndex = index">
								<span
									class="drag-button"
									(mousedown)="
										formItem.draggingItem = value;
										formItem.draggingSource = 'values';
										setDragPosition(multiSelect, formItem, $event);
										formItem.isDraggingItem = true
									"
									(mouseenter)="!formItem.isHeld ? multiSelectClearHold(formItem) : null"
									*ngIf="formItem.allowDragAndDrop"
									><fa-icon [icon]="icons.faGripVertical"></fa-icon>
								</span>
								<span
									class="selectable-item"
									[title]="labels[value.label] ? labels[value.label] : value.label"
									(mouseenter)="
										formItem.focusValueIndex = valueIndex;
										formItem.isHeld ? multiSelectMoveHold(formItem, valueIndex) : null
									"
									(mousedown)="formItem.focusSide = 'value'; multiSelectStartHold(formItem, valueIndex)"
									(mouseup)="multiSelectEndHold(formItem); formItem.focusSide = undefined">
									<span class="item-label">{{ labels[value.label] ? labels[value.label] : value.label }}</span>
									<span class="common-group" *ngIf="value.commonGroup">{{ value.commonGroup }}</span>
								</span>
								<div
									class="drop-option"
									(mouseenter)="moveDragItem(formItem, formItem.draggingSource, 'values', valueIndex)"
									(mouseup)="
										formItem.draggingItem = undefined;
										formItem.draggingSource = undefined;
										formItem.isDraggingItem = false
									"
									*ngIf="formItem.isDraggingItem"></div>
							</div>
						</div>
						<div
							class="drag-screen"
							(mousemove)="setDragPosition(multiSelect, formItem, $event)"
							(mouseup)="formItem.isDraggingItem = false"
							*ngIf="formItem.isDraggingItem"></div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</div>
} @else {
	@if (loadingType === 'dot') {
		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	} @else if (loadingType === 'bar') {
		<cpi-square-post-loading-effect></cpi-square-post-loading-effect>
	}
}
